import React from 'react'
import { Text } from '@/components/atoms/Text'
import { Tag } from '@/components/atoms/Tag'
import './CaseStudyCard.css'

export interface CaseStudyCardProps {
  logoUrl?: string
  logoAlt?: string
  companyName: string
  headline: string
  tags: string[]
  images?: string[]
  imageAlts?: string[]
  className?: string
}


export const CaseStudyCard: React.FC<CaseStudyCardProps> = ({
  logoUrl,
  logoAlt,
  companyName,
  headline,
  tags,
  images,
  imageAlts,
  className = '',
}) => {
  return (
    <div className={`case-study-card ${className}`}>
      <div className="case-study-card-header">
        <div className="case-study-card-company">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={logoAlt || `${companyName} logo`}
              className="case-study-card-logo"
            />
          ) : (
            <div className="case-study-card-logo-placeholder" />
          )}
          <Text size="base" color="primary" weight="normal" className="case-study-card-name">
            {companyName}
          </Text>
        </div>
        <Text size="large" color="primary" weight="bold" className="case-study-card-headline">
          {headline}
        </Text>
      </div>

      <div className="case-study-card-content">
        <div className="case-study-card-tags">
          {tags.map((tag, index) => (
            <Tag key={index} label={tag} />
          ))}
        </div>

        {images && images.length > 0 && (
          <div className="case-study-card-images">
            {images.map((imageUrl, index) => (
              <div key={index} className="case-study-card-image-wrapper">
                <img
                  src={imageUrl}
                  alt={imageAlts?.[index] || `Case study image ${index + 1}`}
                  className="case-study-card-image"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
